import React,  { useEffect, useState} from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import DataManagement from '../src/components/dashboard/DataManagement';
import ModelManagement from '../src/components/dashboard/ModelManagement';
import ModelTesting from '../src/components/dashboard/ModelTesting';
import './styles/Customer.scss';
import './dist/css/style.min.css';
import '../src/index.css'
import { checkEC2StatusAPI } from "../src/service/ModelTestingService";
const authService = require("../src/service/AuthService");


const ModelBuilder = () => {
    const [selectedSection, setSelectedSection] = useState("data");
    const [ec2Context, setEc2Context] = useState(null);
    const [ec2Loading, setEc2Loading] = useState(true);
    const [ec2Error, setEc2Error] = useState(null);

    useEffect(() => {
        const user = authService.getUser();
        if (!user) {
            setEc2Loading(false);
            setEc2Error("No active user session.");
            return;
        }

        const organization = String(user.organization || "").toLowerCase();
        const username = String(user.username || user.name || "").toLowerCase();

        // 1) Try cache first
        const cached = authService.getEc2Context();
        if (cached && cached.instanceId) {
            setEc2Context(cached);
            setEc2Loading(false);
            return;
        }

        // 2) If no cache, resolve once via backend
        (async () => {
            try {
            setEc2Loading(true);
            setEc2Error(null);

            // includeScript=false because here we only care about mapping + EC2 state
            const resp = await checkEC2StatusAPI(organization, username, false);
            console.log("Resolved EC2 context:", resp);
            const context = {
                instanceId: resp.instanceId || "",
                region: resp.ec2Region || resp.region || "us-east-1",
                instanceName: resp.instanceName || resp.ec2InstanceName || "",
            };

            if (!context.instanceId) {
                setEc2Error("No EC2 instance configured for your account.");
            } else {
                setEc2Context(context);
                authService.setEc2Context(context); // 🔐 persist for this session
            }
            } catch (e) {
            console.error("Failed to resolve EC2 context:", e);
            setEc2Error("Failed to resolve EC2 instance. Please try again later.");
            } finally {
            setEc2Loading(false);
            }
        })();
    }, []);


    const handleTabClick = (section) => {
        setSelectedSection(section);
    };

    const renderSection = () => {
        switch (selectedSection) {
            case "model":
                return <ModelManagement 
                        ec2Context={ec2Context}
                        ec2Loading={ec2Loading}
                        ec2Error={ec2Error}/>;
            case "data":
                return <DataManagement />;
            case "test":
                return <ModelTesting 
                        ec2Context={ec2Context}
                        ec2Loading={ec2Loading}
                        ec2Error={ec2Error}/>;
            default:
                return null;
        }
    };

    return (
        <div className="customer-page" style={{ padding: '20px 0', marginTop: "10px" }}>
            <div
                style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '20px',
                    boxSizing: 'border-box',
                }}
            >
                <Typography variant="h6" gutterBottom align="center">
                    Welcome to the <br /><strong>Model Builder Dashboard!</strong>
                </Typography>
                <Typography align="center" style={{ fontSize: "14px", fontWeight: "normal", marginBottom:"30px" }}>
                    Start by managing your data for building a model, or train away using your existing datasets!
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: "14px"}}>
					<Box sx={{ display: 'flex', gap: 1 }}>
						<div
						className={`tab ${selectedSection === 'data' ? 'active-tab' : ''}`}
						onClick={() => handleTabClick('data')}
                        >
						Data Management
						<br></br>
						<p style={{ fontSize: "13px", fontWeight:"normal" }}>
							Add a new dataset, or View and manage <br></br>existing datasets for your organization.
						</p>
						</div>
						<div
						className={`tab ${selectedSection === 'model' ? 'active-tab' : ''}`}
						onClick={() => handleTabClick('model')}
						>
						Model Management

						<br></br>
						<p style={{ display: "inline", fontSize: "13px", fontWeight:"normal" }}>
							Train a new model or manage and rebuild <br></br> existing models using available datasets.<br></br>
						</p>
						</div>

                        <div 
                        className={`tab ${selectedSection === 'test' ? 'active-tab' : ''}`}
                        onClick={() => handleTabClick('test')}>
                            Test
                        <br />
                            <p style={{ display: "inline", fontSize: "13px", fontWeight:"normal" }}>
                                Test and evaluate a trained model for <br></br> inferencing on new or existing test data.
                            </p>
                        </div>
					</Box>
				</Box>

                <div>
                    {renderSection()}
                </div>
            </div>
        </div>
    );
};

export default ModelBuilder;